module.exports = __webpack_public_path__ + "static/media/qr-code.dfa82224.svg";